<template>
  <div id="position">
    <el-table :data="tableData" class="table">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="照片信息">
        <template slot-scope="scope">
          <!-- <img :src="scope.row.img" alt /> -->
          <el-image
            style="margin-right: 10px;float: left;width: 60px;height: 60px;border-radius: 4px;cursor: pointer;"
            :src="scope.row.img"
            @click="handleImgPreview(scope.row)"
          >
            <div slot="error" class="image-slot">
              <img :src="scope.row.errorIcon" alt />
            </div>
          </el-image>
          <div class="fr">
            <p class="code">{{ scope.row.id }}</p>
            <p class="label">
              {{ scope.row.imgType }}
              <span class="size">{{ scope.row.imgSize }}</span>
            </p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下载费用">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.complete">
            <p class="font-red">扣除：1次</p>
          </div>
          <div class="price" v-else>
            <p
              class="font-blue"
              v-if="scope.row.type && !scope.row.isBuy && !scope.row.isOffset"
            >
              单价：1次
            </p>
            <p class="font-blue" v-else>{{ scope.row.msg }}</p>
            <el-button
              type="danger"
              round
              v-if="scope.row.saleType !== null && scope.row.saleType !== ''"
              size="mini"
              >{{ scope.row.saleType }}</el-button
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column label="图片格式">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.value"
            v-if="scope.row.type"
            :disabled="scope.row.disabled"
            placeholder="请选择"
          >
            <el-option
              v-for="item in scope.row.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="操作状态">
        <template slot-scope="scope">
          <div class="processBar" v-if="scope.row.loading"></div>
          <div v-else-if="!scope.row.loading && scope.row.complete">
            <a rel="nofollow" :href="scope.row.downurl" target="_blank"
              ><el-button
                type="primary"
                size="small"
                style="margin-left:5px; margin-top:5px"
                >点击下载</el-button
              ></a
            >
            <a rel="nofollow" :href="scope.row.downurl2" target="_blank"
              ><el-button
                type="success"
                size="small"
                style="margin-left:5px; margin-top:5px"
                >备用下载</el-button
              ></a
            >
            <a rel="nofollow" :href="scope.row.downurl3" target="_blank"
              ><el-button
                type="danger"
                size="small"
                style="margin-left:5px; margin-top:5px"
                >海外下载</el-button
              ></a
            >
          </div>
          <div v-else-if="!scope.row.loading && scope.row.error">
            <p>{{ scope.row.msg }}</p>
          </div>
          <div v-else>
            <el-button
              type="text"
              size="middle"
              @click="deleteRow(scope.$index, tableData)"
              ><i class="el-icon-close"></i
            ></el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :pager-count="11"
      layout="total, sizes, prev, pager, next"
      :total="tableData.length"
      v-if="tableData.length > 100"
    ></el-pagination>
    <div class="btn" v-if="!sureflag">
      <el-button
        type="primary"
        @mousedown.native="sureDownload"
        plain
        icon="el-icon-download"
        :disabled="downflag"
        >确认下载</el-button
      >
    </div>
    <div class="btn2" v-else>
      <div class="el-row">
        <el-button
          type="primary"
          @mousedown.native="batchDownload"
          plain
          icon="el-icon-download"
          >批量下载</el-button
        >
        <el-button
          type="primary"
          @mousedown.native="batchCopy($event)"
          plain
          icon="el-icon-edit-outline"
          style="margin-left:1%;"
          >一键复制下载链接</el-button
        >
      </div>
      <div class="el-row">
        <el-button
          type="primary"
          @mousedown.native="batchDownload1"
          plain
          icon="el-icon-download"
          >批量备用下载</el-button
        >
        <el-button
          type="primary"
          @mousedown.native="batchCopy1($event)"
          plain
          icon="el-icon-edit-outline"
          style="margin-left:1%;"
          >一键复制备用下载链接</el-button
        >
      </div>
      <div class="el-row">
        <el-button
          type="primary"
          @mousedown.native="batchDownload2"
          plain
          icon="el-icon-download"
          >批量海外下载</el-button
        >
        <el-button
          type="primary"
          @mousedown.native="batchCopy2($event)"
          plain
          icon="el-icon-edit-outline"
          style="margin-left:1%;"
          >一键复制海外下载链接</el-button
        >
      </div>
    </div>
    <el-dialog
      :visible.sync="imgPreviewVisible"
      width="50%"
      center
      :show-close="false"
    >
      <template #title>
        <DialogCloseBtn @close="imgPreviewVisible = false" />
        图片预览
      </template>
      <div style="width:100%;text-align:center;max-height:450px;overflow:auto">
        <el-image :src="currentImg">
          <div slot="error" class="image-slot">
            <img
              :src="currentError"
              style="object-fit: fill; width:100%;height:107.5%"
              alt
            />
          </div>
        </el-image>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { hasBlance, buyTemp } from "../../../api/downLoad";
import { message } from "@/utils/resetMessage";
import Clipboard from "clipboard";
import DialogCloseBtn from "@/components/DialogCloseBtn.vue";
import { downloadFile as safeDownloadFile } from "@/utils/download";
// 下载实现已统一收敛到 @/utils/download：
// 那边给 iframe 加了 sandbox，万一下载地址返回的是 HTML（CDN 缺 /topze-dispatch/ 回源规则时
// 会兜底成 SPA 的 index.html），也不会在 iframe 里把整个应用重启、污染同源 localStorage。
export const downloadFile = safeDownloadFile;

export default {
  props: ["data", "sureflag", "downflag", "clearflag"],
  components: {
    DialogCloseBtn,
  },
  watch: {
    clearflag: {
      handler(val) {
        if (val) {
          this.urlArray = [];
          this.urlArray1 = [];
          this.urlArray2 = [];
        }
      },
    },
  },
  computed: {
    tableData() {
      return this.data;
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      urlArray: [], //批量下载
      urlArray1: [], //备用下载
      urlArray2: [], //批量备用下载
      imgPreviewVisible: false,
      currentError: "",
      currentImg: "",
    };
  },
  mounted() {
    //this.cnt.label = "";
    //自动锚点
    this.$EventBus.$on("move", (data) => {
      if (data == "1") {
        this.goAnchor("position");
      }
    });
  },
  methods: {
    popSuccess() {
      if (document.getElementsByClassName("el-message").length > 0) return;
      this.$message({
        message: "下载成功",
        type: "success",
        showClose: true,
        duration: 4000,
        offset: 80,
      });
    },
    handleImgPreview(row) {
      this.imgPreviewVisible = true;
      this.currentImg = "https://img.aatuku.com/preview260/" + row.id + ".jpg";
      this.currentError = row.errorIcon;
    },
    goAnchor(e) {
      var id = "#" + e;
      document.querySelector(id).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    },
    //普通下载
    ordinaryDownload(row, index) {
      let item = this.tableData[index];
      item.isDownload = true;
      downloadFile(row.downurl);
      setTimeout(() => {
        item.isDownload = false;
      }, 1000);
    },
    //备用下载
    standbyDownload(row, index) {
      let item = this.tableData[index];
      item.isDownload1 = true;
      downloadFile(row.downurl2);
      setTimeout(() => {
        item.isDownload1 = false;
      }, 1000);
    },
    //确认下载
    sureDownload() {
      this.urlArray = [];
      this.urlArray1 = [];
      this.urlArray2 = [];
      this.$emit("onSureDown", false);
      this.$emit("onDownload", true);
      //判断是否够余额
      var ids = "";
      var type = "";
      this.tableData.forEach((item) => {
        if (item.type) {
          ids += item.id + ",";
          type = item.webType;
          item.loading = true;
        }
      });
      ids = ids.substring(0, ids.length - 1); //去除最后一个逗号
      let dataform = {
        imageIDs: ids,
        webType: type,
      };
      hasBlance(dataform)
        .then(async (result) => {
          if (result) {
            //如果余额足够，则开始获取下载链接
            let i = 0;
            while (i < this.tableData.length) {
              let item = this.tableData[i];
              if (item.type) {
                //存在才搜索
                let buydata = {
                  imageID: item.id,
                  webType: item.webType,
                  format: item.value,
                  isCos: item.isCos,
                };
                try {
                  let res = await buyTemp(buydata);
                  if (res.downloadUrl != "" && res.downloadUrl != null) {
                    item.complete = true;
                    item.loading = false;
                    item.downurl = res.downloadUrl;
                    item.downurl2 = res.downloadUrl2;
                    item.downurl3 = res.downloadUrl3;
                    item.price = res.price;
                    this.urlArray.push(item.downurl); //批量
                    this.urlArray1.push(item.downurl2); //批量备用下载
                    this.urlArray2.push(item.downurl3); //批量备用下载
                    if (res.time !== "" && res.time != null) {
                      this.$emit("changeTime", res.time);
                    }
                  } else {
                    let res = await buyTemp(buydata);
                    if (res.downloadUrl != "" && res.downloadUrl != null) {
                      item.complete = true;
                      item.loading = false;
                      item.downurl = res.downloadUrl;
                      item.downurl2 = res.downloadUrl2;
                      item.downurl3 = res.downloadUrl3;
                      item.price = res.price;
                      this.urlArray.push(item.downurl); //批量
                      this.urlArray1.push(item.downurl2); //批量备用下载
                      this.urlArray2.push(item.downurl3); //批量备用下载
                      if (res.time !== "" && res.time != null) {
                        this.$emit("changeTime", res.time);
                      }
                    } else {
                      item.loading = false;
                      item.error = true;
                      item.msg = "下载失败，请重新尝试或联系上方微信客服";
                    }
                  }
                } catch (e) {
                  //再试一次
                  // try{
                  //   let res = await buy(buydata).catch(error => {
                  //     flag = false;
                  //   });
                  //   if(flag && (res.downloadUrl != '' && res.downloadUrl != null)){
                  //     item.complete = true;
                  //     item.loading = false;
                  //     item.downurl = res.downloadUrl;
                  //     item.downurl2 = res.downloadUrl2;
                  //     item.price = res.price;
                  //   }else{
                  //     item.loading = false;
                  //     item.error = true;
                  //     item.msg = '下载失败，未扣费，请您联系客服处理';
                  //   }
                  // }catch(e){
                  //     item.loading = false;
                  //     item.error = true;
                  //     item.msg = '下载失败，未扣费，请您联系客服处理';
                  // }
                  item.loading = false;
                  item.error = true;
                  item.msg = "下载失败，请重新尝试或联系上方微信客服";
                }
              }
              if (this.tableData.length == i + 1) {
                //判断是否最后一个
                this.$emit("onSureDown", true);
                this.$emit("onDownload", false);
              }
              i++;
            }
          } else {
            //否则提示
            this.$emit("onSureDown", false);
            this.$emit("onDownload", false);
            message.success({
              message: "您的余额已不足，请充值",
              duration: 4000,
              offset: 80,
            });
          }
        })
        .catch((error) => {
          //余额不足出异常时
          this.$emit("noBanlance", error);
          this.$emit("onSureDown", false);
          this.$emit("onDownload", false);
        });
    },
    async downloadOne(i) {
      //下载单个
    },
    //全部下载
    allDownload() {
      this.popSuccess();
    },
    //批量下载
    batchDownload() {
      for (var g = 0; g < this.urlArray.length; g++) {
        const url = this.urlArray[g];
        window.open(url, "_blank");
      }
    },
    //批量备用下载
    batchDownload1() {
      for (var g = 0; g < this.urlArray1.length; g++) {
        const url = this.urlArray1[g];
        window.open(url, "_blank");
      }
    },
    //批量备用下载
    batchDownload2() {
      for (var g = 0; g < this.urlArray2.length; g++) {
        const url = this.urlArray2[g];
        window.open(url, "_blank");
      }
    },
    batchCopy(e) {
      var text = "";
      for (var g = 0; g < this.urlArray.length; g++) {
        text += this.urlArray[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy1(e) {
      var text = "";
      for (var g = 0; g < this.urlArray1.length; g++) {
        text += this.urlArray1[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    batchCopy2(e) {
      var text = "";
      for (var g = 0; g < this.urlArray2.length; g++) {
        text += this.urlArray2[g].replace("https", "http") + "\n";
      }
      const clipboard = new Clipboard(e.target, { text: () => text });
      clipboard.on("success", (e) => {
        message.success({
          message: "复制成功",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        message.success({
          message: "复制失败，请重试",
          duration: 4000,
          offset: 80,
        });
        // 释放内存
        clipboard.off("error");
        clipboard.off("success");
        clipboard.destroy();
      });
      clipboard.onClick(e);
    },
    deleteRow(index, row) {
      row.splice(index, 1);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
//进度条
.processBar {
  width: 240px;
  height: 7px;
  border: 1px solid #0059ca;
  border-radius: 2px;
  animation: progress-bar-stripes 2s linear infinite;
  background-color: #0773fc;
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  transition: all 0.3s ease;
  -webkit-transition: all 0.3s ease;
  opacity: 1;
}
@-webkit-keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}

@keyframes progress-bar-stripes {
  from {
    background-position: 40px 0;
  }
  to {
    background-position: 0 0;
  }
}
.table {
  .el-table__body {
    img {
      margin-right: 10px;
      float: left;
      width: 60px;
      height: 60px;
      border-radius: 4px;
    }
    .fr {
      .code {
        margin-top: 5px;
        margin-bottom: 5px;
        font-size: 14px;
        color: #578ade;
        .label {
          font-size: 16px;
          color: #43424b;
        }
      }
      .size {
        padding-left: 10px;
        font-size: 10px !important;
      }
    }
    .el-button--mini.is-round {
      padding: 4px 10px;
      span {
        font-size: 10px;
      }
    }
    .price {
      .font-blue {
        color: #0773fc;
      }
      .font-red {
        color: #f56c6c;
      }
      .font-green {
        color: #67c23a;
      }
    }
  }
}
.btn {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 100%;
    font-size: 16px;
    color: #0773fc;
    border-color: #0773fc;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #0773fc;
    border-color: #0773fc;
    color: #ffffff;
  }
}

.btn2 {
  margin: 20px 0 100px;
  .el-button {
    margin-bottom: 20px;
    margin-left: 0;
    padding: 15px 20px;
    width: 49.5%;
    font-size: 16px;
    color: #0773fc;
    border-color: #0773fc;
    outline: none;
    i {
      font-size: 16px;
    }
  }
  .el-button--primary.is-plain:hover {
    background: #0773fc;
    border-color: #0773fc;
    color: #ffffff;
  }
}

.el-pagination {
  margin: 20px 0 30px;
}
</style>
